<!--
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-11-23 15:39:14
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2024-01-08 09:54:15
 * @LastEditTime: 2023-12-19 17:06:06
-->
<template>
	<div class="flex flex-align-center">
		<div
			class="tab-button yx-color-text-p-4 font-h4-regular"
			:class="[curTab === item.name ? 'active' : '']"
			v-for="(item, index) in list"
			:key="index"
			@click="click(item.name, item)"
		>
			<slot :item="item"></slot>
		</div>
	</div>
</template>
<script>
export default {
	name: 'SubTabs',
	props: {
		value: [Number, String],
		list: [Array],
	},
	watch: {
		value(val) {
			this.curTab = val;
		},
	},
	created() {
		this.curTab = this.value;
	},
	data() {
		return {
			curTab: '',
		};
	},
	methods: {
		click(val, item) {
			this.$emit('input', val);
			this.$emit('tab-click', val, item);
		},
	},
};
</script>
<style lang="less" scoped>
.tab-button {
	height: 32px;
	padding: 0 16px 0 16px;
	line-height: 32px;
	border: 1px solid @color-gy5;
	border-radius: 4px;
	cursor: pointer;
	& + & {
		margin-left: 8px;
	}
	&.active {
		color: @color-primary;
		border: 1px solid @color-primary;
		background: @color-b1;
	}
}
</style>
